import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../context/api";
import { AuthContext } from "../context/AuthContext";
import "../styles/Forcasters.css";

const PLAN_OPTIONS = [
    { weeks: 1, amount: 10, label: "Subscribe 1 Week" },
    { weeks: 2, amount: 15, label: "Subscribe 2 Weeks" },
];

const Forcasters = () => {
    const { isLoggedIn, setUserBalance } = useContext(AuthContext);
  const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [submittingRegister, setSubmittingRegister] = useState(false);
    const [subscribingKey, setSubscribingKey] = useState("");
    const [forecasters, setForecasters] = useState([]);
    const [myProfile, setMyProfile] = useState(null);
    const [showForecasterPopup, setShowForecasterPopup] = useState(false);
    const [forecasterName, setForecasterName] = useState("");
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [bio, setBio] = useState("");

    const displayedForecasters = (() => {
        if (!myProfile?.isForecaster) {
            return forecasters;
        }

        const meInList = forecasters.some(
            (item) => String(item?._id) === String(myProfile?._id)
        );

        if (meInList) {
            return forecasters;
        }

        return [
            {
                _id: myProfile._id,
                fullName: myProfile.fullName,
                forecasterBio: myProfile.forecasterBio,
                forecasterStars: myProfile.forecasterStars || 0,
                forecasterSubscribersCount: myProfile.forecasterSubscribersCount || 0,
                isSubscribed: false,
                subscription: null,
            },
            ...forecasters,
        ];
    })();

    const fetchData = useCallback(async () => {
        if (!isLoggedIn) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            const [profileRes, listRes] = await Promise.allSettled([
                api.get("/forecasters/me"),
                api.get("/forecasters"),
            ]);

            if (profileRes.status === "fulfilled") {
                setMyProfile(profileRes.value?.data || null);
              setForecasterName((profileRes.value?.data?.forecasterDisplayName || profileRes.value?.data?.fullName || "").trim());
                setBio((profileRes.value?.data?.forecasterBio || "").trim());
            }

            if (listRes.status === "fulfilled") {
                setForecasters(Array.isArray(listRes.value?.data) ? listRes.value.data : []);
            } else {
                setForecasters([]);
            }
        } catch (error) {
            setForecasters([]);
        } finally {
            setLoading(false);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleRegisterForecaster = async () => {
        try {
            setSubmittingRegister(true);
        const response = await api.post("/forecasters/register", {
          forecasterName,
          bio,
          agreeToTerms,
        });

        if (response?.data?.approvalStatus === "pending") {
          alert("Your forecaster request has been sent to admin for approval.");
        }

        setShowForecasterPopup(false);
        setAgreeToTerms(false);

            await fetchData();
        } catch (error) {
            alert(error?.response?.data?.error || "Could not register as forecaster.");
        } finally {
            setSubmittingRegister(false);
        }
    };

    const handleSubscribe = async (forecasterId, durationWeeks) => {
        const key = `${forecasterId}-${durationWeeks}`;
        try {
            setSubscribingKey(key);
            const response = await api.post("/forecasters/subscribe", {
                forecasterId,
                durationWeeks,
            });

            if (typeof response.data?.subscriberBalance === "number") {
                setUserBalance(response.data.subscriberBalance);
            }

            await fetchData();
            alert("Subscription successful.");
        } catch (error) {
            alert(error?.response?.data?.error || "Subscription failed.");
        } finally {
            setSubscribingKey("");
        }
    };

      const uiForecasters = displayedForecasters.map((item) => ({
        ...item,
        rankPoints: item.forecasterStars || 0,
        status: "HOT! Game Ready",
      }));

    if (!isLoggedIn) {
        return (
          <div className="forecasters-page">
            <main className="main-content">
              <div className="title-section">
                    <h2>Forecasters</h2>
                    <p>Please login to register or subscribe to forecasters.</p>
              </div>
            </main>
                </div>
        );
    }

  return (
    <div className="forecasters-page">
      {/* Header / Navigation */}
      <header className="hero-header">
        <div className="hero-overlay">
          <h1 className="site-title">Ghana NLA 5/90 Lotto Forecasters</h1>
          <div className="header-actions">
            <button className="header-btn" onClick={() => setShowForecasterPopup(true)}>Subscribe as a Forecaster</button>
            <button className="header-btn" onClick={() => navigate("/services")}>Play 5/90 Game</button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        <div className="title-section">
          <h2 className="main-title">5/90 Lotto Forecasters</h2>
          <p className="subtitle">
            Forecasting has never being easy without well acclaimed forecasters
          </p>
          {myProfile?.forecasterApprovalStatus === "pending" ? (
            <p className="approval-note">Your forecaster request is pending admin approval.</p>
          ) : null}
          <div className="search-row">
            <span className="search-label">Who are you looking for?</span>
            {/* Could be an input field, but matches the design style */}
          </div>
        </div>

        {/* Cards Grid */}
        <div className="cards-grid">
          {loading ? (
            <p>Loading forecasters...</p>
          ) : uiForecasters.length === 0 ? (
            <p>No forecasters available yet.</p>
          ) : (
            uiForecasters.map((forecaster, index) => {
              const isSelf = String(forecaster._id) === String(myProfile?._id);

              return (
              <div className="forecaster-card" key={forecaster._id || index}>
              <h3 className="forecaster-name">{forecaster.fullName || "Unknown"}</h3>
              <div className="rank-points">
                <span className="points-label">Rank Points:</span>{" "}
                <span className="points-value">{forecaster.rankPoints}</span>
              </div>
              <div className="status">{forecaster.status}</div>
              {isSelf ? (
                <button className="subscribe-button" disabled>
                  Your Profile
                </button>
              ) : forecaster.isSubscribed ? (
                <button className="subscribe-button" disabled>
                  Subscribed
                </button>
              ) : (
                PLAN_OPTIONS.map((plan) => {
                  const key = `${forecaster._id}-${plan.weeks}`;
                  return (
                    <button
                      key={key}
                      className="subscribe-button"
                      onClick={() => handleSubscribe(forecaster._id, plan.weeks)}
                      disabled={subscribingKey === key || !forecaster._id}
                    >
                      {subscribingKey === key
                        ? "Processing..."
                        : `${plan.label} - GHS ${plan.amount}`}
                    </button>
                  );
                })
              )}
            </div>
          );
            })
          )}
        </div>

        {/* Optional footer or extra design element, clean */}
        <div className="design-footer"></div>
      </main>

      {showForecasterPopup ? (
        <div className="popup-backdrop" onClick={() => setShowForecasterPopup(false)}>
          <div className="popup-card" onClick={(event) => event.stopPropagation()}>
            <h3>Apply as Forecaster</h3>
            <p>Enter your forecaster name and agree to terms before sending for admin approval.</p>

            <label className="popup-label">Forecaster Name</label>
            <input
              type="text"
              className="popup-input"
              value={forecasterName}
              onChange={(event) => setForecasterName(event.target.value)}
              placeholder="Enter forecaster display name"
            />

            <label className="popup-label">Bio (Optional)</label>
            <textarea
              className="popup-textarea"
              value={bio}
              onChange={(event) => setBio(event.target.value)}
              placeholder="Tell users about your forecast strategy"
              rows={3}
            />

            <label className="popup-check-row">
              <input
                type="checkbox"
                checked={agreeToTerms}
                onChange={(event) => setAgreeToTerms(event.target.checked)}
              />
              <span>I agree to forecast terms.</span>
            </label>

            <div className="popup-actions">
              <button className="popup-btn ghost" onClick={() => setShowForecasterPopup(false)}>
                Cancel
              </button>
              <button
                className="popup-btn primary"
                onClick={handleRegisterForecaster}
                disabled={submittingRegister || !forecasterName.trim() || !agreeToTerms}
              >
                {submittingRegister ? "Sending..." : "Send for Approval"}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Forcasters;
